<template>
  <v-menu
    v-model="open"
    :close-on-content-click="false"
    location="bottom end"
    :offset="[0, 8]"
  >
    <!-- Activator -->
    <template #activator="{ props: menuProps }">
      <v-btn
        v-bind="menuProps"
        color="error"
        variant="text"
        :class="activatorClass"
        :icon="activatorIcon"
        title="Löschen"
        aria-label="Löschen"
      >
        <template v-if="activatorIcon">
          <v-icon>mdi-delete-outline</v-icon>
        </template>

        <template v-else>
          <v-icon start>mdi-delete-outline</v-icon>
          <slot>Löschen</slot>
        </template>
      </v-btn>
    </template>

    <!-- Confirmation -->
    <v-card
      class="delete-confirmation-card"
      elevation="8"
    >
      <div class="delete-confirmation-header">
        <div class="delete-icon">
          <v-icon
            color="error"
            size="24"
          >
            mdi-alert-outline
          </v-icon>
        </div>

        <div>
          <div class="delete-title">
            Wirklich löschen?
          </div>

          <div class="delete-subtitle">
            Diese Aktion kann nicht rückgängig gemacht werden.
          </div>
        </div>
      </div>

      <v-divider />

      <div class="delete-actions">
        <v-btn
          variant="text"
          :disabled="loading"
          @click="open = false"
        >
          Abbrechen
        </v-btn>

        <v-btn
          color="error"
          variant="elevated"
          :loading="loading"
          @click="launch"
        >
          <v-icon start>mdi-delete-outline</v-icon>
          Löschen
        </v-btn>
      </div>
    </v-card>
  </v-menu>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

defineProps({
  activatorClass: {
    type: [String, Array, Object],
    default: '',
  },

  activatorIcon: {
    type: Boolean,
    default: false,
  },

  loading: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['click'])

const open = ref(false)

function launch() {
  emit('click')
  open.value = false
}
</script>

<style scoped lang="scss">
.delete-confirmation-card {
  width: min(360px, calc(100vw - 2rem));
  overflow: hidden;

  border: 1px solid rgba(var(--v-theme-error), 0.2);
  border-radius: 20px;

  color: rgb(var(--v-theme-on-surface));
  background-color: rgb(var(--v-theme-surface));
}

/* ========================================
   Confirmation text
======================================== */

.delete-confirmation-header {
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;

  padding: 1rem;
}

.delete-icon {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;

  width: 42px;
  height: 42px;
  border-radius: 999px;

  background-color: rgba(var(--v-theme-error), 0.1);
}

.delete-title {
  color: rgb(var(--v-theme-on-surface));

  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.35;
}

.delete-subtitle {
  margin-top: 0.2rem;

  color: rgba(var(--v-theme-on-surface), 0.65);

  font-size: 0.82rem;
  line-height: 1.45;
}

/* ========================================
   Actions
======================================== */

.delete-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;

  padding: 0.75rem 1rem;
}

.delete-actions .v-btn {
  font-weight: 600;
  text-transform: none;
}

/* ========================================
   Responsive
======================================== */

@media (max-width: 500px) {
  .delete-confirmation-card {
    width: calc(100vw - 1.5rem);
    border-radius: 18px;
  }

  .delete-actions {
    align-items: stretch;
    flex-direction: column-reverse;
  }

  .delete-actions .v-btn {
    width: 100%;
  }
}
</style>